import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { config } from '../helper/config';

@Injectable({
  providedIn: 'root'
})
export class FarmerpastdataService {
  liftingData: any;
  inventoryData: any;
  vanId: any;
  constructor(public http: HttpClient) { }


  pastInventories(data): Observable<any> {
    return this.http.post(config.api + 'pastInventory/broilerInventoryList',data);
  }

  

  pastLiftings(data): Observable<any> {
    return this.http.post(config.api + 'pastInventory/liftings',data);
  }

  pastExpenses(data): Observable<any> {
    return this.http.post(config.api + 'pastInventory/expenses',data);
  }
  setSelectedLiftingInventoryData(data) {
    this.liftingData = data;
  }
  setData(data) {
    this.inventoryData = data;
  }
  getData() {
    return this.inventoryData
  }


  //layers past data
  layerPastInventories(data): Observable<any> {
    return this.http.post(config.api + 'pastInventory/layersInventories',data);
  }  

  layerPastInventorySales(data): Observable<any> {
    return this.http.post(config.api + 'pastInventory/layerPastInventorySales',data);
  }
  
  layerPastInventoryExpenses(data): Observable<any> {
    return this.http.post(config.api + 'pastInventory/layerPastInventoryExpenses',data);
  }

  vandDriverId(data){
    this.vanId =data;
  }

  getLiftingVanData(){
    return this.vanId;
  }

}
